import {
	approveAgentRun,
	cancelAgentRun,
	getAgentRun,
	getAgentRuns,
	getAgents,
	rejectAgentRun,
	updateAgentStatus,
} from '@/services/ai/aiAgents.service'

export default {
	namespaced: true,
	state: {
		runList: { data: [], meta: { total: 0 } },
		runStatus: 'init',
		runDetail: null,
		runDetailStatus: 'init',
		runActionStatus: 'init',
		agentList: { data: [], meta: { total: 0 } },
		agentStatus: 'init',
		agentActionStatus: 'init',
		agentOptions: [],
	},
	getters: {
		getRunList: (state) => state.runList,
		getRunStatus: (state) => state.runStatus,
		getRunDetail: (state) => state.runDetail,
		getRunDetailStatus: (state) => state.runDetailStatus,
		getRunActionStatus: (state) => state.runActionStatus,
		getAgentList: (state) => state.agentList,
		getAgentStatus: (state) => state.agentStatus,
		getAgentActionStatus: (state) => state.agentActionStatus,
		getAgentOptions: (state) => state.agentOptions,
	},
	mutations: {
		SET_RUN_LIST(state, val) {
			state.runList = val
		},
		SET_RUN_STATUS(state, val) {
			state.runStatus = val
		},
		SET_RUN_DETAIL(state, val) {
			state.runDetail = val
		},
		SET_RUN_DETAIL_STATUS(state, val) {
			state.runDetailStatus = val
		},
		SET_RUN_ACTION_STATUS(state, val) {
			state.runActionStatus = val
		},
		SET_AGENT_LIST(state, val) {
			state.agentList = val
		},
		SET_AGENT_STATUS(state, val) {
			state.agentStatus = val
		},
		SET_AGENT_ACTION_STATUS(state, val) {
			state.agentActionStatus = val
		},
		SET_AGENT_OPTIONS(state, val) {
			state.agentOptions = val
		},
	},
	actions: {
		async fetchRuns({ commit }, params) {
			commit('SET_RUN_STATUS', 'pending')
			try {
				const { data } = await getAgentRuns(params)
				commit('SET_RUN_LIST', data)
				commit('SET_RUN_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_RUN_STATUS', 'init')
				throw error
			}
		},
		async fetchRun({ commit }, uuid) {
			commit('SET_RUN_DETAIL_STATUS', 'pending')
			try {
				const { data } = await getAgentRun(uuid)
				commit('SET_RUN_DETAIL', data.data || data)
				commit('SET_RUN_DETAIL_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_RUN_DETAIL_STATUS', 'init')
				throw error
			}
		},
		async approveRun({ commit }, uuid) {
			commit('SET_RUN_ACTION_STATUS', 'pending')
			try {
				const { data } = await approveAgentRun(uuid)
				commit('SET_RUN_ACTION_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_RUN_ACTION_STATUS', 'init')
				throw error
			}
		},
		async rejectRun({ commit }, uuid) {
			commit('SET_RUN_ACTION_STATUS', 'pending')
			try {
				const { data } = await rejectAgentRun(uuid)
				commit('SET_RUN_ACTION_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_RUN_ACTION_STATUS', 'init')
				throw error
			}
		},
		async cancelRun({ commit }, uuid) {
			commit('SET_RUN_ACTION_STATUS', 'pending')
			try {
				const { data } = await cancelAgentRun(uuid)
				commit('SET_RUN_ACTION_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_RUN_ACTION_STATUS', 'init')
				throw error
			}
		},
		async fetchAgents({ commit }, params) {
			commit('SET_AGENT_STATUS', 'pending')
			try {
				// Agents table renders without client pagination — fetch the full list.
				const { data } = await getAgents({ per_page: 'all', ...params })
				commit('SET_AGENT_LIST', data)
				commit('SET_AGENT_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_AGENT_STATUS', 'init')
				throw error
			}
		},
		async fetchAgentOptions({ commit }) {
			const { data } = await getAgents({ per_page: 'all' })
			commit('SET_AGENT_OPTIONS', data.data || data)
			return data
		},
		async toggleAgentStatus({ commit }, { uuid, status }) {
			commit('SET_AGENT_ACTION_STATUS', 'pending')
			try {
				const { data } = await updateAgentStatus(uuid, status)
				commit('SET_AGENT_ACTION_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_AGENT_ACTION_STATUS', 'init')
				throw error
			}
		},
	},
}
